import { render, staticRenderFns } from "./tvr_invite.vue?vue&type=template&id=3007e0e0&scoped=true"
import script from "./tvr_invite.vue?vue&type=script&lang=js"
export * from "./tvr_invite.vue?vue&type=script&lang=js"
import style0 from "./tvr_invite.vue?vue&type=style&index=0&id=3007e0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007e0e0",
  null
  
)

export default component.exports